// src/pages/MPFlow/phases/Phase1Profile.jsx
import React, { useState, useCallback } from 'react';
import { CpuChipIcon } from '@heroicons/react/24/outline';
import EdyMascot from '../components/EdyMascot';
import EddyChat from '../components/EddyChat';
import apiClient from '../../../lib/apiClient';

const LS_KEY   = 'mp_onboarding_progress';
const SESS_KEY = 'mp_session_id';

function genSessionId() {
  return 'sess_' + Math.random().toString(36).slice(2) + Date.now();
}

export default function Phase1Profile({ onNext }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChatComplete = useCallback(async (answers) => {
    setLoading(true);
    setError('');
    try {
      let sessionId = localStorage.getItem(SESS_KEY) || genSessionId();
      localStorage.setItem(SESS_KEY, sessionId);

      // Persiste no backend
      const res = await apiClient.request('/mp/onboarding', {
        method: 'POST',
        body: JSON.stringify({ ...answers, session_id: sessionId }),
      });

      const sid = res?.session_id || sessionId;
      localStorage.setItem(SESS_KEY, sid);

      // Atualiza localStorage com progresso
      try {
        const saved = JSON.parse(localStorage.getItem(LS_KEY) || '{}');
        localStorage.setItem(LS_KEY, JSON.stringify({ ...saved, ...answers, session_id: sid, status: 'in_progress' }));
      } catch {}

      onNext({ ...answers, session_id: sid });
    } catch {
      setError('Erro ao salvar. Tente novamente.');
      setLoading(false);
    }
  }, [onNext]);

  if (loading) {
    return (
      <div className="mp-loading">
        <div className="mp-loading__icon"><CpuChipIcon className="icon-xl" /></div>
        <div className="mp-loading__dots"><span /><span /><span /></div>
        <p className="mp-loading__msg">Preparando sua campanha...</p>
      </div>
    );
  }

  return (
    <div className="mp-phase1-chat">
      <EdyMascot phase="perfil" />
      {error && <div className="mp-alert mp-alert--error mp-mb-4">{error}</div>}
      <EddyChat onComplete={handleChatComplete} />
    </div>
  );
}
